<template>
	<div class="leave-message-fastword">
		<TreeBox @handleTreeClick="handleTreeClick"></TreeBox>
	</div>
</template>

<script>
	import TreeBox from '@/views/system/fastWords/tree.vue';
	export default {
		components:{
			TreeBox
		},
		methods:{
			handleTreeClick(source){
				let results = '';
				switch (source.type){
					case 'text':
						results = source.content;
						break;
					case 'image':
					case 'video':
						results = source.attachment;
						break;
					case 'miniprogrampage':
						results = source.miniProgram
						break;
					case 'news':
						results = source
						break;
				}
				this.$emit('finish',{
					type:source.type,
					source:results
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.leave-message-fastword {
		height: 100%;
		overflow: auto;
	}
</style>